import React, { useEffect, useState } from "react";
import "./Listeruser.css";
import { withRouter } from "react-router-dom";
import { Box, Button,Chip, Grid, IconButton, makeStyles, Tooltip, useMediaQuery } from "@material-ui/core";
import { Edit, Archive, CheckCircleOutline, Block, Unarchive, Add, PersonAdd } from "@material-ui/icons";
import { getAll, archiveUser } from "../Services/UserService";
import { CircularProgress } from "@material-ui/core";
import { theme } from "../../utils/Theme";
import DialogModal from "../../utils/DialogModal";
import MUIDataTable from "mui-datatables";
import { withSnackbar } from "../../utils/SnackbarHOC";
import { handleOnViewColumnsChange, displayColumn } from "../../utils/viewColumns";
import { getRowData } from "../../utils/FunctionHelpers";
import { ROLE } from "../../enums/rolesEnum";
import { cleanRole, toSortableRoles } from "../../utils/DataTables";



const useStyles = makeStyles(() => ({
  buttonProgress: {
    color: "rgb(17, 122, 167)",
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  archiveButton: {
    color: "white",
    fontWeight: 500,
    backgroundColor: "rgb(17, 122, 167)",
    marginBottom: "10px",
    "&:hover": {
      backgroundColor: "rgb(17, 122, 167)"
    }
  },
  enabled: {
    color: "#4BB543"
  },
  disabled: {
    color: "#D2042D"
  },
  action: {
    display: 'ce'
  }
}));

const Listeruser = ({ history, snackbarShowMessage }) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [loadingAction, setLoadingAction] = useState(false);
  const [reloadData, setReloadData] = useState(false);

  const editUser = (uuid) => {
    history.push({
      pathname: "/users/" + uuid + "/update",
    });
  };

  useEffect(() => {
    setLoading(true);
    (async () => {
      try {
        const response = await getAll();
        setUsers(response.data.users);
      } catch (error) {
        snackbarShowMessage("Erreur de chargement des utilisateur.", "error", 4000);
      } finally {
        setLoading(false);
      }
    })();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reloadData]);

  const handleArchiverUser = (data, handleClose) => {
    setLoadingAction(true);
    archiveUser(data).then(() => {
      snackbarShowMessage(
        `L'utilisateur a été ${data.status ? 'activé': 'désactivé'} avec succès`,
        'success',
        4000
      );
      setReloadData(!reloadData);
      handleClose();
    }).catch(error => {
      snackbarShowMessage(
        `Erreur ${data.status ? "d'activage" : "de désactivage"
        } de l'utilisateur.`,
        "error",
        4000
      );
    }).finally(() => {
      setLoadingAction(false);
    })
  }

  const handleShowArchiveButton = (utilisateur, status) => {
    const dialogProps = {
      label: status ? <Archive className={classes.disabled} /> : <Unarchive className={classes.enabled} />,
      description: `Voulez vous ${status ? 'désactiver' : 'activer'} l'utilisateur ?`,
      title: `${status ? 'Désactiver' : 'Activer'} l'utilisateur ?`,
      closeLabel: "Annuler",
      confirmLabel: status ? 'Activer' : 'Désactiver',
      loading: loadingAction,
      onConfirm: handleArchiverUser,
      data: {
        user: utilisateur,
        status: !status
      },
    };
    return <Box><DialogModal {...dialogProps} /></Box>;
  };

  const handleShowCheck = (status) => {
    if (status) return <CheckCircleOutline className={classes.enabled} />
    return <Block className={classes.disabled} />
  }

  const tableName = "usersColumnVisibility";
  const columns = [
    {
      name: "uuid",
      label: "N°UTILISATEUR",
      options: {
        display: false,
        setCellProps: () => ({ style: { whiteSpace: "nowrap", textOverFlow: "ellipsis", overflow: "hidden", maxWidth: "100px" } }),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <Box data-toggle="tooltip" title={value} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", width: "100px" }}>{value !== null ? value : "---"}</Box>
            </>
          );
        },
      },
    },
    {
      name: "prenom",
      label: "PRÉNOM",
      options: {
        display: displayColumn("prenom", tableName),
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textTransform: "capitalize" } }),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <Box data-toggle="tooltip" title={value} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", width: "100px" }}>{value !== null ? value : "---"}</Box>
            </>
          );
        },
      },
    },

    {
      name: "nom",
      label: "NOM",
      options: {
        display: displayColumn("nom", tableName),
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textTransform: "uppercase" } }),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <Box data-toggle="tooltip" title={value} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", width: "100px" }}>{value !== null ? value : "---"}</Box>
            </>
          );
        },
      },
    },
    {
      name: "localisation",
      label: "LOCALISATION",
      options: {
        display: displayColumn("localisation", tableName),
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textTransform: "uppercase" } }),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <Box data-toggle="tooltip" title={value} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", width: "50px" }}>{value !== null ? value : "---"}</Box>
            </>
          );
        },
      },
    },
    {
      name: "fonction",
      label: "FONCTION",
      options: {
        display: displayColumn("fonction", tableName),
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <Box data-toggle="tooltip" title={value} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", width: "100px" }}>{value !== null ? value : "---"}</Box>
            </>
          );
        },
      },
    },
    {
      name: "passworduser",
      label: "PASSWORD",
      options: {
        display: displayColumn("passworduser", tableName),
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <Box data-toggle="tooltip" title={value}> {localStorage.getItem("rolecurrentuser") === "ROLE_ADMIN" ? (value) : ("")} </Box>
            </>
          );
        },
      },
    },
    {
      name: "tel_mobile",
      label: "TÉL MOBILE",
      options: {
        display: displayColumn("tel_mobile", tableName),
        filter: true,
        sort: true,
        setCellHeaderProps: () => ({ style: { whiteSpace: "nowrap" } }),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Box data-toggle="tooltip" title={value} sx={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" }}>{value !== null ? value : "---"}</Box>
          );
        },
      },
    },
    {
      name: "email",
      label: "EMAIL",
      options: {
        display: displayColumn("email", tableName),
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <Box data-toggle="tooltip" title={value} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", width: "100px" }}>{value !== null ? value : "---"}</Box>
            </>
          );
        },
      },
    },
    {
      name: "role",
      label: "STATUT",
      options: {
        display: displayColumn("role", tableName),
        filter: true,
        filterType: "multiselect",
        sort: true,
        sortCompare: (order) => (obj1, obj2) => {
          const value1 = toSortableRoles(obj1.data);
          const value2 = toSortableRoles(obj2.data);
          return (order === "asc" ? 1 : -1) * value1.localeCompare(value2, undefined, { sensitivity: "base" });
        },
        customBodyRender: (value, tableMeta, updateValue) => {
          const userRoles = Array.isArray(value) ? value : value ? [value] : [];
          return (
            <Tooltip title={userRoles.map(cleanRole).join(", ")}>
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                {userRoles.map((role) => (
                  <Chip key={role} size="small" label={cleanRole(role)} />
                ))}
              </Box>
            </Tooltip>
          );
        },
        filterOptions: {
          names: Object.values(ROLE),
          logic: (value, filters) => {
            if (!filters || filters.length === 0) return false;
            const userRoles = Array.isArray(value) ? value : value ? [value] : [];
            return !filters.some((filter) => userRoles.includes(filter));
          },
        },
        customFilterListOptions: {
          render: (value) => cleanRole(value),
        },
      },
    },
    {
      name: "isActive",
      label: "ETAT",
      options: {
        display: displayColumn("isActive", tableName),
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Box data-toggle="tooltip" title={value} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", width: "50px" }}>
              { handleShowCheck(value) }
            </Box>
          );
        },
      },
    },
    {
      name: "Action",
      label: "ACTION",
      options: {
        customBodyRender: (data, tableMeta, updateValue) => {
          const row = getRowData(tableMeta, columns);
          return (
            <>
              {localStorage.getItem("rolecurrentuser") === "ROLE_ADMIN" &&
                <Box sx={{ maxWidth: "100px"}}>
                  <Grid container>
                    <Grid item xs={6} sm={6} md={6} lg={6}>
                      <Button data-toggle="tooltip" title="Modifier" onClick={() => editUser(row.uuid)} style={{ color: "#C8D148", paddingTop: '12px' }}>
                        <Edit />
                      </Button>
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} lg={6} >
                      { handleShowArchiveButton( row.uuid, row.isActive ) }
                    </Grid>
                  </Grid>
                </Box>
              }
            </>

          );
        },
      },
    },
  ];

  const options = {
    tableBodyMaxHeight: "none",
    rowsPerPageOptions: [],
    rowsPerPage: 50,
    textLabels: {
      body: {
        noMatch: loading ? <CircularProgress /> : "Désolé, il n'y a aucun enregistrement dans la base de données pour le moment.",
      },
    },
    onViewColumnsChange: (columnName, action) => {
      handleOnViewColumnsChange(columnName, action, tableName);
    },
    selectableRows: "none",
    draggableColumns: {
      enabled: true,
    },
    filterType: "dropdown"
  };
  const isSmMode = useMediaQuery(theme.breakpoints.between(0, 480));

  const handleAddUser = () => {
    history.push("/users/add")
  }

  return (
    <Box sx={{ padding: "0 20px " }}>
      <Grid container style={{ paddingBottom: "5px" }}>
        <Grid item xs={10} sm={6} md={6} xl={6}>
          <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
            <h2 className="text-capitalize" style={{ color: "rgb(17, 122, 167)" }}>
              LISTE DES UTILISATEURS

            </h2>
          </Box>
        </Grid>
        <Grid item xs={2} sm={6} md={6} xl={6}>
          <Box sx={{ display: "flex", justifyContent: "end" }}>
            {!isSmMode ?
              <Button startIcon={<PersonAdd />} onClick={() => handleAddUser()} className={classes.archiveButton}>
                UTILISATEUR
              </Button>
              : <IconButton size="medium" data-toggle="tooltip"
                title="Ajouter">
                <Add />
              </IconButton>}
          </Box>
        </Grid>
      </Grid>
      <Box className="user_container">
        <MUIDataTable data={users} columns={columns} options={options} />
      </Box>
    </Box >
  );
};

export default withSnackbar(withRouter(Listeruser));
